import React, { Component, Fragment } from 'react'
import { Mutation } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import moment from 'moment-business-days'
import { SUBMIT_ORDER, SUBMIT_OCI_ORDER } from '../../mutations'
import Input from '../../components/Input'
import { HOOK_URL, OCI } from '../../constants'

import DayPickerInput from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css'

import 'moment/locale/nl'

import { FlexContainer } from '../../styles/defaults'
import {
  ProductContainer,
  OrderContainer,
  Title,
  Amount,
  Button,
  StickyOrder,
  StickyAmount,
  StickyButton,
  ProductHeader,
  ProductTitle,
  Content,
  Wrapper,
  DesktopWrapper,
  MobileWrapper,
  Price,
  StickyPrice
} from '../Orders/styles'

import { DayPickerWrapper, StatusBar, StyledLink } from './styles'

import Order from '../Order/'
import SubmitOrderPopup from '../SubmitOrderPopup/'
import SubmitOCIOrderPopup from '../SubmitOCIOrderPopup/'
import EmployeeCTA from '../EmployeeCTA/'

import employee from '../../assets/cta/employee.png'

class ShoppingCartOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filteredProducts: [],
      popupActive: false,
      query: '',
      reference: this.props.wholeOrder.clientReference ? this.props.wholeOrder.clientReference : '',
      deliveryDate: ''
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleDayClick = this.handleDayClick.bind(this)
  }

  calculateOrders() {
    let amount = 0
    Object.keys(this.props.order).map((key, index) => {
      return (amount = amount + this.props.order[key])
    })
    return amount
  }

  calculatePrice() {
    let price = 0
    this.props.wholeOrder.orderParts.map((orderPart) => {
      // Search for priceAgreements with the same product, sort by priority and take the last one
      const priceAgreementsProduct = this.props.priceAgreements ? this.props.priceAgreements.filter(priceAgreement => priceAgreement.productCode === orderPart.product.productCode) : false
      const priceAgreementSorted = priceAgreementsProduct.length > 0 ? priceAgreementsProduct.sort((a, b) => a.priority - b.priority)
      .filter((item, index, array) => item.priority === array[0].priority) : false
      const priceAgreement = priceAgreementSorted.length > 0 ? priceAgreementSorted[0] : false
      let orderPartPrice = priceAgreement ? priceAgreement.percentage ? orderPart.product.price * ((100 - priceAgreement.percentage) / 100) : priceAgreement.price : orderPart.product.price
      // orderPartPrice = orderPart.product.category.category === 'SUP' ? 0 : orderPartPrice
      price = price + orderPartPrice * orderPart.amount
      return price
    })
    return price > 0 ? Number(price).toFixed(2).replace('.', ',') : false
  }

  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })

    const { strippedProducts } = this.props

    const result =
      queryLength === 0
        ? []
        : strippedProducts.filter(
            product =>
              product.firstDescription.toLowerCase().slice(0, queryLength) === query ||
              product.firstDescription.toLowerCase().indexOf(query) !== -1 ||
              product.productCode.toLowerCase().slice(0, queryLength) === query
          )
    if (result.length > 0) {
      this.setState({ filteredProducts: result })
    } else {
      this.setState({ filteredProducts: [] })
    }
  }

  handleDayClick(day) {
    this.setState({ deliveryDate: day });
  }

  handleClick(e) {
    this.setState({ popupActive: true })
    document.body.classList.add('popup-active')
    document.documentElement.classList.add('popup-active')
  }

  closePopup() {
    this.setState({ popupActive: false })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }

  handleChange(e) {
    this.setState({ reference: e.target.value })
  }
  
  render() {
    let employeeContent = {
      title: 'Vragen?',
      subtitle: 'We helpen u graag',
      employee: true,
      image: employee,
      link: {
        content: 'Contact',
        url: '/contact',
        target: ''
      }
    }
    
    const hookUrl = window.sessionStorage.getItem(HOOK_URL)
    const ociPlatform = window.sessionStorage.getItem(OCI)
    console.log(this.props)

    const order = this.props.wholeOrder
    this.order = order
    let productTypes = {
      coffee: {
        description: 'Koffie',
        products: order.orderParts.filter(orderPart =>
          ['KFB', 'KFBF', 'KFG', 'KFGF', 'KFL', 'KFLF', 'KFV', 'KFVF', 'KFBRA', 'KFGRF', 'KFVRF'].includes(orderPart.product.category.category) && orderPart.amount > 0
        ),
        productsWithoutAmount: order.orderParts.filter(orderPart =>
          ['KFB', 'KFBF', 'KFG', 'KFGF', 'KFL', 'KFLF', 'KFV', 'KFVF', 'KFBRA', 'KFGRF', 'KFVRF'].includes(orderPart.product.category.category) && orderPart.amount < 1
        ),
      },
      thee: {
        description: 'Thee',
        products: order.orderParts.filter(orderPart => ['THE', 'THEF', 'THERF'].includes(orderPart.product.category.category) && orderPart.amount > 0),
        productsWithoutAmount: order.orderParts.filter(orderPart => ['THE', 'THEF', 'THERF'].includes(orderPart.product.category.category) && orderPart.amount < 1)
      },
      food: {
        description: 'Food',
        products: order.orderParts.filter(orderPart =>
          ['SOE', 'KOE', 'CAC', 'TOP', 'SUI', 'MLK', 'FRI', 'OFO'].includes(orderPart.product.category.category) && orderPart.amount > 0
        ),
        productsWithoutAmount: order.orderParts.filter(orderPart =>
          ['SOE', 'KOE', 'CAC', 'TOP', 'SUI', 'MLK', 'FRI', 'OFO'].includes(orderPart.product.category.category) && orderPart.amount < 1
        )
      },
      nonFood: {
        description: 'Non-food',
        products: order.orderParts.filter(orderPart =>
          ['BEK', 'BEP', 'ROE', 'HYG', 'SMK', 'REI', 'SER', 'ONF', 'FIL'].includes(orderPart.product.category.category) && orderPart.amount > 0
        ),
        productsWithoutAmount: order.orderParts.filter(orderPart =>
          ['BEK', 'BEP', 'ROE', 'HYG', 'SMK', 'REI', 'SER', 'ONF', 'FIL'].includes(orderPart.product.category.category) && orderPart.amount < 1
        )
      },
      sup: {
        description: 'SUP-heffingen',
        products: order.orderParts.filter(orderPart =>
        {
          return ociPlatform && (ociPlatform === 'Axxerion') && orderPart.product.category.category === 'SUP' && orderPart.amount > 0
        }
        ),
        productsWithoutAmount: []
      },
      notes: {
        description: 'Notities',
        products: order.orderParts.filter(orderPart =>
          ['TXT'].includes(orderPart.product.category.category)
        ),
        productsWithoutAmount: []
      }
    }


    // Disable today, weekends and make sure the selected day is always 2 working days in the future
    let disabledDays = [
      new Date(),
      moment('20200413').toDate(),
      moment('20200427').toDate(),
      moment('20200505').toDate(),
      moment('20200521').toDate(),
      moment('20200601').toDate(),
      moment('20201225').toDate(),
      moment('20210101').toDate(),
      moment().businessAdd(1).toDate(),
      {
        daysOfWeek: [0, 6],
      },
      {
        before: new Date()
      }
    ]

    let minimalOrderValueNotice = false

    if (this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) {
      if (Number(this.calculatePrice().replace(',', '.')) < this.props.branchData.minimalOrderValue) {
        const difference = this.props.branchData.minimalOrderValue - Number(this.calculatePrice().replace(',', '.'))
        minimalOrderValueNotice = `Je bestelling heeft nog niet de waarde van het minimale orderbedrag bereikt.<br/>
        Als je nog voor <strong>€${difference.toFixed(2).replace('.', ',')}</strong> bijbestelt dan brengen wij de bezorgkosten á €25,- niet in rekening!<br/><br/><a href="/bestellijst"><strong>Pas hier je bestelling aan</strong></a>`
      }
    }

    return (
      <FlexContainer full mb>
        {minimalOrderValueNotice ? (
          <StatusBar dangerouslySetInnerHTML={{__html: minimalOrderValueNotice}} /> 
        ) : null}
        <ProductContainer>
          {Object.keys(productTypes).map((type, index) => {
            if (productTypes[type].products.length > 0) {
              return (
                <Fragment key={index}>
                  <ProductHeader>
                    <ProductTitle>{productTypes[type].description}</ProductTitle>
                  </ProductHeader>
                  {productTypes[type].products.map((orderPart, index) => {
                    return (
                      <Order
                        small={true}
                        key={orderPart.product.id + '-' + index}
                        product={orderPart.product}
                        wholeOrder={this.props.wholeOrder}
                        orderParts={this.props.order}
                        priceAgreements={this.props.priceAgreements}
                        viewPrices={this.props.viewPrices}
                        orderId={this.props.orderId}
                        order={this.props.order[`${orderPart.id}`]}
                        editOrder={this.props.editOrder}
                        servicePackage={this.props.servicePackage}
                        noAmount={false}
                        branchData={this.props.branchData}
                      />
                    )
                  })}
                </Fragment>
              )
            } else {
              return null
            }
          })}
        </ProductContainer>

        <OrderContainer>
          <Wrapper secondChild>
            <Title>Bestellijst</Title>
            <Amount>
              Producten
              <strong>{this.calculateOrders()} st.</strong>
            </Amount>
            {(this.props.viewPrices && this.calculatePrice() && hookUrl) || (this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
              <Price>
                Totaal
                <strong>€ {this.calculatePrice()}</strong>
              </Price>
            ) : null}
            {(this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
              <Price>
                Minimale orderwaarde
                <strong>€ {this.props.branchData.minimalOrderValue.toFixed(2).replace('.', ',')}</strong>
              </Price>
            ) : null}
            {!hookUrl ? (
              <Content>
                <h4>Referentie</h4>
                <Input type='text' value={this.state.reference} handleChange={this.handleChange.bind(this)} placeholder={'Geef hier uw referentie op'}  />
                {order.code !== '35' && order.code !== '40' ? (
                  <Fragment>
                    <h4>Gewenste leverdatum</h4>
                    <span>Standaard levering binnen 2 á 3 werkdagen</span>
                    <DayPickerWrapper>
                      <DayPickerInput
                        formatDate={formatDate}
                        parseDate={parseDate}
                        format="L"
                        placeholder={`${formatDate(moment().businessAdd(2).toDate(), 'DD-MM-YYYY', 'nl')}`}
                        inputProps={{ readOnly: true }}
                        dayPickerProps={{
                          locale: 'nl',
                          localeUtils: MomentLocaleUtils,
                          disabledDays: disabledDays,
                          onDayClick: this.handleDayClick
                        }}
                      />
                    </DayPickerWrapper>
                  </Fragment>
                ) : null}
              </Content>
            ) : null}
            {this.calculateOrders() > 0 ? (
              <Fragment>
                {this.props.sendOrder ? (
                  <Button onClick={this.handleClick.bind(this)}>{order.submitted || (order.code === '30' || order.code === '35') ? 'Wijziging versturen' : 'Bestellen'}</Button>
                ) : null}
              </Fragment>
              ) : <Fragment></Fragment>}
             <StyledLink href="/bestellijst">Bestelling aanpassen</StyledLink>

            
          </Wrapper>
          <DesktopWrapper>
            <EmployeeCTA size={'small'} mt content={employeeContent} />
          </DesktopWrapper>
        </OrderContainer>

        {this.state.popupActive ? (
          <Fragment>
            {hookUrl ? (
              <Mutation mutation={SUBMIT_OCI_ORDER}>
                {(submitOCIOrder, { data, loading, error }) => {
                  if (data) {
                    console.log(data)
                    document.body.classList.remove('popup-active')
                    document.documentElement.classList.remove('popup-active')
                    // this.props.history.push('/bestellijst/bedankt')
                    // window.location.href = hookUrl
                  }

                  return (
                    <SubmitOCIOrderPopup
                      closePopup={this.closePopup.bind(this)}
                      id={this.props.orderId}
                      submitOrder={submitOCIOrder}
                      order={this.props.wholeOrder}
                      type="ociOrder"
                      hookUrl={hookUrl}
                      priceAgreements={this.props.priceAgreements}
                      branch={this.props.branch}
                      ociPlatform={ociPlatform}
                      reference={this.state.reference}
                      deliveryDate={this.state.deliveryDate}
                      title={'Weet u zeker dat u deze bestelling wilt versturen?'}
                      confirm={'Ja, verzend deze bestelling'}
                      deny={'Annuleren'}
                      user={this.props.user}
                    />
                  )
                }}
              </Mutation>
            ) : (
              <Mutation mutation={SUBMIT_ORDER}>
                {(submitOrder, { data, loading, error }) => {
                  if (data) {
                    document.body.classList.remove('popup-active')
                    document.documentElement.classList.remove('popup-active')
                    // this.props.history.push('/bestellijst/bedankt')
                    window.location.href = '/bestellijst/bedankt'
                  }

                  return (
                    <SubmitOrderPopup
                      closePopup={this.closePopup.bind(this)}
                      id={this.props.orderId}
                      submitOrder={submitOrder}
                      type="order"
                      reference={this.state.reference}
                      deliveryDate={this.state.deliveryDate}
                      title={'Weet u zeker dat u deze bestelling wilt versturen?'}
                      confirm={'Ja, verzend deze bestelling'}
                      deny={'Annuleren'}
                      user={this.props.user}
                    />
                  )
                }}
              </Mutation>
            )}
          </Fragment>
        ) : null}
        <Content mobile>
          <h4>Referentie</h4>
          <Input type='text' value={this.state.reference} handleChange={this.handleChange.bind(this)} placeholder={'Geef hier uw referentie op'}  />
        </Content>
        <Content mobile>
          {order.code !== '35' && order.code !== '40' ? (
            <Fragment>
              <h4>Gewenste leverdatum</h4>
              <span>Standaard levering binnen 2 werkdagen</span>
              <DayPickerWrapper>
                <DayPickerInput
                  formatDate={formatDate}
                  parseDate={parseDate}
                  format="L"
                  placeholder={`${formatDate(moment().businessAdd(2).toDate(), 'DD-MM-YYYY', 'nl')}`}
                  inputProps={{ readOnly: true }}
                  dayPickerProps={{
                    locale: 'nl',
                    localeUtils: MomentLocaleUtils,
                    disabledDays: disabledDays,
                    onDayClick: this.handleDayClick
                  }}
                />
              </DayPickerWrapper>
            </Fragment>
          ) : null}
        </Content>
        <StickyOrder>
          <StickyAmount>
            Producten
            <strong>{this.calculateOrders()} st.</strong>
          </StickyAmount>
          {(this.props.viewPrices && this.calculatePrice() && hookUrl) || (this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
            <StickyPrice>
              Totaal
              <strong>€ {this.calculatePrice()}</strong>
            </StickyPrice>
          ) : null}
          {(this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
            <StickyPrice>
              Minimale orderwaarde
              <strong>€ {this.props.branchData.minimalOrderValue.toFixed(2).replace('.', ',')}</strong>
            </StickyPrice>
          ) : null}
          {this.calculateOrders() > 0 ? (
            <Fragment>
              {this.props.sendOrder ? (
                <StickyButton onClick={this.handleClick.bind(this)}>{order.submitted || (order.code === '30' || order.code === '35') ? 'Wijziging versturen' : 'Bestellen'}</StickyButton>
              ) : null}
            </Fragment>
          ) : (
            null
          )}

        </StickyOrder>
        <MobileWrapper>
            <EmployeeCTA size={'small'} mt content={employeeContent} />
          </MobileWrapper>
      </FlexContainer>
    )
  }
}

export default withRouter(ShoppingCartOrders)



// WEBPACK FOOTER //
// ./src/components/ShoppingCartOrders/index.js